/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FormUtility } from "./FormUtility";
import { getCidUserLocalId } from "./Utils/WebTrackingUtils";
var JsonFormSerializationBuilder = /** @class */ (function () {
    function JsonFormSerializationBuilder(publishedFormUrl, submissionType) {
        this.data = {
            publishedFormUrl: publishedFormUrl,
            fields: []
        };
        submissionType && (this.data.submissionType = submissionType);
        var cidUserLocalId = getCidUserLocalId();
        if (!!cidUserLocalId) {
            this.data.cidUserLocalId = cidUserLocalId;
        }
        var registrationId = FormUtility.getEventRegistrationId();
        if (!!registrationId) {
            this.add("eventRegistrationId", registrationId);
        }
    }
    JsonFormSerializationBuilder.prototype.build = function () {
        return {
            contentType: "application/json",
            data: JSON.stringify(__assign(__assign({}, this.data), { fields: this.data.fields.map(function (p) { return (__assign(__assign({}, p), { details: JSON.stringify(p.details) })); }) }))
        };
    };
    JsonFormSerializationBuilder.prototype.add = function (key, value, lookupname) {
        this.data.fields.push({ key: key, value: value, lookupname: lookupname });
    };
    JsonFormSerializationBuilder.prototype.update = function (key, value, lookupname) {
        var formProperty = this.data.fields.find(function (x) { return x.key === key; });
        if (formProperty) {
            formProperty.value = value;
            formProperty.lookupname = lookupname !== null && lookupname !== void 0 ? lookupname : formProperty.lookupname;
        }
    };
    JsonFormSerializationBuilder.prototype.updateLabels = function (key, fieldLabels, valueLabel, savedFieldId) {
        var formProperty = this.data.fields.find(function (x) { return x.key === key; });
        if (formProperty) {
            formProperty.details = __assign(__assign({}, formProperty.details), { fieldLabels: fieldLabels, valueLabel: valueLabel, savedFieldId: savedFieldId });
            // limit the length
            if (!!formProperty.details.fieldLabels) {
                formProperty.details.fieldLabels = formProperty.details.fieldLabels.map(function (l) { return l.trim().substring(0, 100); });
            }
            if (formProperty.details.valueLabel) {
                formProperty.details.valueLabel = formProperty.details.valueLabel.trim().substring(0, 500);
            }
            if (JSON.stringify(formProperty.details).length > 1000) {
                formProperty.details = {
                    fieldLabels: [],
                    valueLabel: null,
                    savedFieldId: savedFieldId
                };
            }
        }
    };
    JsonFormSerializationBuilder.prototype.get = function (key) {
        return this.data.fields.find(function (x) { return x.key === key; });
    };
    JsonFormSerializationBuilder.prototype.setEventSubmissionType = function (eventSubmissionType) {
        if (eventSubmissionType) {
            this.data.eventSubmissionType = eventSubmissionType;
        }
    };
    return JsonFormSerializationBuilder;
}());
export { JsonFormSerializationBuilder };
